import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DeliveryTicketRoutingModule } from './delivery-ticket-routing.module';
import { DeliveryTicketComponent } from './delivery-ticket.component';
import { TicketDeliveryCreationComponent } from './ticket-delivery-creation/ticket-delivery-creation.component';
import { TicketDeliveryCreationModule } from './ticket-delivery-creation/ticket-delivery-creation.module';


@NgModule({
  declarations: [DeliveryTicketComponent],
  imports: [
    CommonModule,
    DeliveryTicketRoutingModule,
    TicketDeliveryCreationModule
  ],
  exports: [DeliveryTicketComponent]
})
export class DeliveryTicketModule { }
